<template>
  <div ref="gantt"></div>
</template>

<script>
import "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_tooltip.js";
// import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_quick_info.js";
import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_csp.js";
import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_smart_rendering.js";
// import "dhtmlx-gantt/codebase/locale/locale_de.js";
const uuidv4 = require("uuid/v4");

export default {
  name: "ProjectManagementGantt",
  props: {
    tasks: {
      type: Object,
      default() {
        return { data: [], links: [] };
      },
    },
  },
  methods: {
    // Updates start date and end date of parent tasks if a child was updated
    // updateParentTaskDates(changedTask) {
    //   var parentTaskId = gantt.getParent(changedTask);
    //   if (!parentTaskId) return;

    //   // Update the parent of the changed task to fit the duration
    //   var parentTask = gantt.getTask(parentTaskId);
    //   var siblings = gantt.getChildren(parentTask.id);
    //   if (siblings.length > 0) {
    //     var minStartDate = gantt.getTask(siblings[0]).start_date;
    //     var maxEndDate = gantt.getTask(siblings[0]).end_date;

    //     for (var i = 1; i < siblings.length; i++) {
    //       if (minStartDate > gantt.getTask(siblings[i]).start_date)
    //         minStartDate = gantt.getTask(siblings[i]).start_date;
    //       if (maxEndDate < gantt.getTask(siblings[i]).end_date)
    //         maxEndDate = gantt.getTask(siblings[i]).end_date;
    //     }

    //     if (maxEndDate <= minStartDate)
    //       maxEndDate.setDate(minStartDate.getDate() + 1);

    //     parentTask.start_date = minStartDate;
    //     parentTask.end_date = maxEndDate;
    //   }
    //   gantt.updateTask(parentTask.id);
    // },

    // Updates start date and end date of children tasks if a parent was updated
    // updateChildrenTaskDates(changedTask) {
    //   var children = gantt.getChildren(changedTask.id);
    //   if (children.length < 1) return;

    //   // Update the children of the changed task to fit the duration
    //   var child;
    //   for (var i = 0; i < children.length; i++) {
    //     child = gantt.getTask(children[i]);
    //     if (child.start_date < changedTask.start_date)
    //       child.start_date = changedTask.start_date;
    //     if (child.end_date > changedTask.end_date)
    //       child.end_date = changedTask.end_date;

    //     if (child.end_date <= child.start_date)
    //       if (child.start_date == changedTask.start_date)
    //         child.end_date = gantt.date.add(child.start_date, 1, "day");
    //       else child.start_date = gantt.date.add(child.end_date, -1, "day");

    //     this.updateChildrenTaskDates(child);
    //   }
    // },

    // Deletes all children from the changed task
    deleteChildren(changedTask) {
      var children = gantt.getChildren(changedTask.id);
      if (children) {
        for (var i = 0; i < children.length; i++) {
          gantt.deleteTask(children[i]);
          this.$emit("task-updated", children[i], "deleted");
        }
      }
    },

    // Initializes events
    $_initGanttEvents() {
      if (gantt.$_eventsInitialized) return;

      gantt.attachEvent("onTemplatesReady", () => {
        // parse
        gantt.templates.xml_date = (dateString) => {
          return new Date(dateString);
        };
        // stringify
        gantt.templates.xml_format = (date) => {
          var isoDate = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          ).toISOString();
          return isoDate;
        };
      });

      gantt.attachEvent("onTaskCreated", (task) => {
        var parentTask = gantt.getTask(gantt.getParent(task));
        task.id = uuidv4();
        if (parentTask.type == gantt.config.types.project) {
          task.type = gantt.config.types.wave; // Projects can only contain waves
          task.text = "New wave";
        } else if (parentTask.type == gantt.config.types.wave) {
          task.type = gantt.config.types.scenario; // Waves can only contain scenarios
          task.text = "New scenario";
        } else return false; // No subtasks for scenarios
        return true;
      });

      // gantt.attachEvent("onTaskDblClick", id => {
      //   if (!id) return false;
      //   // There is only one project that can not be deleted
      //   if (gantt.getTask(id).type == gantt.config.types.project) return false;
      //   return true;
      // });

      gantt.attachEvent("onAfterTaskAdd", (id, task) => {
        // this.updateParentTaskDates(task);

        this.$emit("task-updated", id, "inserted", task);
        gantt.render();
      });
      gantt.attachEvent("onAfterTaskUpdate", (id, task) => {
        if (
          task.type == gantt.config.types.project &&
          task.end_date <= task.start_date
        )
          task.end_date.setDate(task.start_date.getDate() + 1);

        // this.updateParentTaskDates(task);
        // this.updateChildrenTaskDates(task);

        this.$emit("task-updated", id, "updated", task);
        gantt.render();
      });
      gantt.attachEvent("onAfterTaskDelete", (id, task) => {
        // this.updateParentTaskDates(task);

        this.$emit("task-updated", id, "deleted");
        gantt.render();
      });

      gantt.attachEvent("onBeforeTaskDelete", (id, task) => {
        this.deleteChildren(task);
      });

      // Hide delete button for project
      gantt.attachEvent("onBeforeLightbox", (id) => {
        let task = gantt.getTask(id);

        if (task.type === "project")
          $(".gantt_delete_btn_set").css("display", "none");
        else
          setTimeout(() => {
            // The timeout is a workaround for no visible delete button at first opening
            $(".gantt_delete_btn_set").css("display", "block");
          }, 1);

        return true;
      });

      // Store current task to remove reportingVisibility settings later for non wave tasks
      gantt.attachEvent("onBeforeLightbox", (id) => {
        this.currentLightboxTask = gantt.getTask(id);
        return true;
      });
      gantt.attachEvent("onAfterLightbox", () => {
        if (this.currentLightboxTask.type !== "wave")
          delete this.currentLightboxTask.reportingVisibility;
      });

      // gantt.attachEvent("onTaskDrag", (id, mode, task, original) => {
      //   var formatFunc = gantt.date.date_to_str("%d/%m/%Y");
      //   if (
      //     formatFunc(task.start_date) == formatFunc(gantt.getState().min_date)
      //   ) {
      //     gantt.getState().min_date = gantt.date.add(
      //       gantt.getState().min_date,
      //       -1,
      //       "day"
      //     );
      //     gantt.render();
      //     gantt.showDate(gantt.getState().min_date);
      //   } else if (
      //     formatFunc(task.end_date) == formatFunc(gantt.getState().max_date)
      //   ) {
      //     gantt.getState().max_date = gantt.date.add(
      //       gantt.getState().max_date,
      //       2,
      //       "day"
      //     );
      //     gantt.render();
      //     gantt.showDate(gantt.getState().max_date);
      //   }
      // });

      gantt.$_eventsInitialized = true;
    },
  },
  mounted() {
    this.$_initGanttEvents();
    gantt.init(this.$refs.gantt);
    gantt.parse(this.$props.tasks);
    gantt.config.autosize = true;

    gantt.config.lightbox.sections = [
      {
        name: "description",
        height: 70,
        map_to: "text",
        type: "textarea",
        focus: true,
      },
      {
        name: "time",
        height: 35,
        map_to: "auto",
        type: "time",
      },
      {
        name: "rep",
        type: "checkbox",
        map_to: "reportingVisibility",
        options: [
          {
            key: "true",
            label: "Visible in reporting?",
          },
        ],
        default_value: true,
      },
    ];

    gantt.config.scale_unit = "week";
    gantt.config.scale_height = 50;
    gantt.config.date_scale = "%F, %Y, W%W";
    gantt.config.subscales = [{ unit: "day", step: 1, date: "%j, %D" }];

    gantt.config.show_progress = false;
    gantt.config.show_links = false;
    gantt.config.drag_move = false;
    gantt.config.drag_resize = false;

    gantt.config.columns = [
      { name: "text", width: "*", tree: true, resize: true },
      {
        name: "start_date",
        label: "Start date",
        template: (task) => {
          return gantt.templates.task_date(task.start_date);
        },
        align: "center",
      },
      {
        name: "end_date",
        label: "End date",
        template: (task) => {
          return gantt.templates.task_date(
            gantt.date.add(task.end_date, 0, "day")
          );
        },
        align: "center",
      },
      { name: "add", label: "", width: 44 },
    ];

    gantt.config.types.wave = "wave";
    gantt.config.types.scenario = "scenario";
    gantt.locale.labels.type_wave = "New Wave";
    gantt.locale.labels.type_scenario = "New Scenario";

    gantt.locale.labels.section_rep = "Reporting";

    // Set checkbox state and hide checkbox for non wave tasks
    gantt.form_blocks.checkbox.set_value = function (node, value, task) {
      node.firstChild.firstChild.checked = !!value;
      var style = task.type === "wave" ? "" : "none";
      node.style.display = style; // editor area
      node.previousSibling.style.display = style; //section header
      gantt.resizeLightbox(); //correct size of lightbox
    };
    // Store checkbox state as boolean instead of string array
    gantt.form_blocks.checkbox.get_value = function (node, task) {
      let checked = node.firstChild.firstChild.checked;
      return checked;
    };

    // gantt.locale = this.lang;
    // console.log(gantt.locale);
    // if (globals.selectedLanguage == "de")
    //   require("dhtmlx-gantt/codebase/locale/locale_de.js");

    gantt.templates.task_class = (start, end, task) => {
      if (task.type == gantt.config.types.wave) {
        return "wave_task";
      }
      if (task.type == gantt.config.types.scenario) {
        return "scenario_task";
      }
      return "";
    };

    gantt.templates.grid_row_class = (start, end, task) => {
      if (task.$level > 1) {
        return "no_subtasks";
      }
      return "";
    };

    gantt.config.readonly = true;
  },
  data() {
    return {
      currentLightboxTask: null,
      lang: {
        date: {
          month_full: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
          month_short: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          day_full: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
          day_short: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        },
        labels: {
          new_task: "New task",
          icon_save: "Save",
          icon_cancel: "Cancel",
          icon_details: "Details",
          icon_edit: "Edit",
          icon_delete: "Delete",
          confirm_closing: "Your changes will be lost, are you sure?",
          confirm_deleting: "Task will be deleted permanently, are you sure?",

          section_description: "Description",
          section_time: "Time period",
          section_type: "Type",
          section_rep: "Reporting",

          column_text: "Task Name",
          column_start_date: "Start datee",
          column_end_date: "End datee",
          column_duration: "Duration",
          column_add: "",

          confirm_link_deleting:
            "Dependency will be deleted permanently, are you sure?",
          link_from: "From",
          link_to: "To",
          link_start: "Start",
          link_end: "End",

          type_task: "Task",
          type_project: "Project",
          type_milestone: "Milestone",
          type_wave: "Wave",
          type_scenario: "Scenario",

          minutes: "Minutes",
          hours: "Hours",
          days: "Days",
          weeks: "Week",
          months: "Months",
          years: "Years",
        },
      },
    };
  },
};
</script>

<style>
@import "~dhtmlx-gantt/codebase/skins/dhtmlxgantt_material.css";

div.gantt_cal_light {
  height: auto !important;
  padding: 15px 10px 5px;
  z-index: 2000;
}
div.gantt_cal_cover {
  z-index: 1999;
}

.gantt_cal_larea {
  height: auto !important;
}

.gantt_grid_head_add {
  visibility: hidden;
}

.gantt_cal_light_wide .gantt_section_time {
  height: 35px !important;
  margin: 5px;
}
.gantt_cal_light_wide .gantt_cal_ltext {
  margin: 5px;
  padding: 0 !important;
  min-height: 28px;
}
.gantt_cal_light_wide .gantt_cal_ltext > label {
  margin-top: 5px;
}
.gantt_cal_light_wide .gantt_cal_ltext > label > input {
  margin: 5px;
}

.gantt_cal_light_wide .gantt_cal_lsection {
  height: auto;
  width: 100px;
  margin-right: 10px;
}

div.gantt_modal_box {
  min-width: 300px;
  z-index: 2002;
}
div.dhx_modal_cover {
  z-index: 2001;
}

.gantt_save_btn_set {
  float: right;
  background: var(--color-primary-input) !important;
}
.gantt_save_btn_set:hover {
  background: var(--color-primary-input-hover) !important;
}
.gantt_cancel_btn_set {
  float: right;
  background: #eee !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
.gantt_cancel_btn_set:hover {
  background: #e4e4e4 !important;
}
.gantt_delete_btn_set {
  float: left !important;
}
.gantt_ok_button {
  background: var(--color-primary-input) !important;
}
.gantt_ok_button:hover {
  background: var(--color-primary-input-hover) !important;
}
.gantt_cancel_button {
  background: #eee !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
.gantt_cancel_button:hover {
  background: #e4e4e4 !important;
}

/* .no_subtasks .gantt_add {
  display: none;
} */

.gantt_add {
  display: none;
}

.gantt_delete_btn_set {
  display: none;
}

/* Task colors */
.wave_task {
  border: none;
  color: #6ba8e3;
  background: #417d34;
}
.wave_task .gantt_task_progress {
  background: #2d5624;
}

.scenario_task {
  border: none;
  color: #6ba8e3;
  background: #bc3e3b;
}
.scenario_task .gantt_task_progress {
  background: #702523;
}
</style>



// WEBPACK FOOTER //
// ProjectManagementGantt.vue?4c0a55f8